<template>
  <div >
    <div class="base-item">
      <div class="title">{{$t('crm_partner_examine_detail_personal.ji_chu_xin_xi')}}</div>
      <div class="row">
        <div class="col">
          <div class="key">{{$t('crm_partner_examine_detail_personal.gong_si_lei_xing')}}</div>
          <div class="val">{{ getDicValue('bas_org_type', data.partnerType) }}</div>
        </div>
        <div class="col">
          <div class="key">{{$t('crm_partner_examine_detail_personal.gong_si_bian_hao')}}</div>
          <div class="val">{{  data.partnerCode }}</div>
        </div>
        <div class="col">
          <div class="key">{{$t('crm_partner_examine_detail_personal.shou_ji_hao_ma')}}</div>
          <div class="val">{{ data.telephone }}</div>
        </div>
        <div class="col">
          <div class="key">{{$t('crm_partner_examine_detail_personal.you_xiang')}}</div>
          <div class="val">{{ data.email }}</div>
        </div>
      </div>
      <div class="row">
        <div class="col" v-if="data.timeZoneDto && timeZoneCountOverOne">
          <div class="key">
            {{ $t('crm_partner_examine_detail_personal.shi_qu') }}
          </div>
          <div class="val">
            {{ `(${data.timeZoneDto.utcZoneName})` }} {{ data.timeZoneDto.timeZoneRegion }}
          </div>
        </div>
        <div class="col long">
          <div class="key">{{$t('crm_partner_examine_detail_personal.ju_zhu_di_zhi')}}</div>
          <div class="val">{{ [data.country, data.province, data.city].join("")
            }}{{ data.detailAddress }}</div>
        </div>
      </div>
    </div>
    <div class="base-item">
      <div class="title">{{$t('crm_partner_examine_detail_personal.sfzxx')}}</div>
      <div class="row">
        <div class="col">
          <div class="key">{{$t('crm_partner_examine_detail_personal.xing_ming')}}</div>
          <div class="val">{{ data.legalPerson }}</div>
        </div>
        <div class="col">
          <div class="key">{{$t('crm_partner_examine_detail_personal.shen_fen_zheng_hao')}}</div>
          <div class="val">{{ data.legalPersonIdentity }}</div>
        </div>

        <div class="col">
          <div class="key">{{$t('crm_partner_examine_detail_personal.zheng_jian_zhao')}}</div>
          <div class="val">
            <span class="detail" @click="visible2 = true">{{$t('Common.com_detail')}}</span>
          </div>
        </div>
      </div>
    </div>

    <img-detail-dialog
      :bizData="idPhotoData"
      :title="$t('crm_partner_examine_detail_personal.zheng_jian_zhao')"
      v-if="visible2"
      @close="visible2 = false"
    ></img-detail-dialog>
    <img-detail-dialog
      :bizData="licenseData"
      :title="$t('crm_partner_examine_detail_personal.zjhdcsfrdjzs')"
      v-if="visible"
      @close="visible = false"
    ></img-detail-dialog>
  </div>
</template>

<script>
// import apis from '@/utils/apis';

export default {
  components: {
  },
  props: {
    data: {
      type: Object,
      default() {
        return {};
      }
    },
    partnerId: String
  },
  computed: {
    // 证件照biz数据
    idPhotoData() {
      return [
        // 身份证人像面
        {
          bizId: this.partnerId,
          bizType: 'crm.id.face'
        },
        // 身份证国徽面
        {
          bizId: this.partnerId,
          bizType: 'crm.id.reverse'
        }
      ];
    },
    // 营业执照biz数据
    licenseData() {
      return [
        {
          bizId: this.partnerId,
          bizType: 'crm.partner.license'
        }
      ];
    },
    timeZoneCountOverOne() {
      return this.$store.state.timeZoneCount > 1;
    },
  },
  // watch: {
  //   data(val) {
  //     if (val && val.orgId) {
  //       this.getTableList();
  //     }
  //   }
  // },
  data() {
    return {
      // 营业执照图片
      visible: false,
      // 证件照
      visible2: false,
      tableCode: 'company_admin_info',
      tableList: []
    };
  },
  methods: {
    // getTableList() {
    //   this.$getJSON(`${apis.partnerOrganAdminItem}/${this.data.partnerOrgId}`).then(
    //     (res) => {
    //       this.tableList = [res.data];
    //     }
    //   );
    // }
  },
  mounted() {
  }
};
</script>

<style lang="scss" scoped>

</style>
